import { useEffect, useState } from 'react';
import { useStore } from '@tanstack/react-form';
import Input from '@/shared/components/elements/Input';
import Select from '@/shared/components/elements/Select';
import Button from '@/shared/components/elements/Button';
import { noDataCondition } from '../utils/noDataCondition';

export default function NoDataFields({ form }) {
  const values = useStore(form.store, (state) => state.values);
  useEffect(() => {
    form.setFieldValue(
      'duration_seconds',
      String(
        Number(values.expected_interval_seconds) *
          Number(values.missed_intervals),
      ),
    );
  }, [form, values.expected_interval_seconds, values.missed_intervals]);
  const [unit, setUnit] = useState(
    Number(values.expected_interval_seconds) % 60 ? '1' : '60',
  );
  let error = '';
  try {
    noDataCondition(values);
  } catch (e) {
    error = e.message;
  }
  const update = (interval, missed) => {
    form.setFieldValue('expected_interval_seconds', interval);
    form.setFieldValue('missed_intervals', missed);
    form.setFieldValue(
      'duration_seconds',
      String(Number(interval) * Number(missed)),
    );
  };
  return (
    <div className="space-y-3 rounded-xl border border-blue-200 bg-blue-50/60 p-4 dark:border-blue-800 dark:bg-blue-950/20">
      <div className="grid gap-3 sm:grid-cols-3">
        <Input
          label="بازه معمول ارسال دستگاه"
          type="number"
          min={1 / Number(unit)}
          step="any"
          value={
            values.expected_interval_seconds === ''
              ? ''
              : Number(values.expected_interval_seconds) / Number(unit)
          }
          onChange={(e) =>
            update(
              e.target.value === ''
                ? ''
                : Number(e.target.value) * Number(unit),
              values.missed_intervals,
            )
          }
          required
        />
        <Select
          label="واحد زمان"
          value={unit}
          onChange={setUnit}
          options={[
            { value: '60', label: 'دقیقه' },
            { value: '1', label: 'ثانیه' },
            { value: '3600', label: 'ساعت' },
          ]}
        />
        <Input
          label="پس از چند بازه بدون داده؟"
          type="number"
          min="1"
          max="100"
          step="1"
          value={values.missed_intervals}
          onChange={(e) =>
            update(values.expected_interval_seconds, e.target.value)
          }
          required
        />
      </div>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => {
          setUnit('60');
          update(1800, 2);
        }}
      >
        نمونه TS4: ارسال هر ۳۰ دقیقه، هشدار پس از ۶۰ دقیقه
      </Button>
      {error ? (
        <p role="alert" className="text-sm text-red-600 dark:text-red-400">
          {error}
        </p>
      ) : (
        <p className="text-sm font-semibold dark:text-gray-100">
          مهلت هشدار:{' '}
          {(Number(values.duration_seconds) / 60).toLocaleString('fa-IR')} دقیقه
          بدون دریافت داده
        </p>
      )}
      <p className="text-sm leading-7 text-gray-600 dark:text-gray-300">
        هر عضو تگ جداگانه پایش می‌شود. برای هر دورهٔ بی‌داده یک هشدار ثبت و با
        برگشت داده رفع می‌شود. ارسال پیام به کانال متصل به قانون بستگی دارد. پس
        از فعال‌سازی یا عضویت جدید، یک مهلت کامل در نظر گرفته می‌شود.
      </p>
    </div>
  );
}
